<script>
import forminput from "../formcomponet/forminput.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import dpagecategories from "@/models/dpagecategories";
import dpagecategoriestranslations from "../dpagecategoriestranslations/addedit.vue";

export default {
  mixins: [apibtoast, apigeneric, dpagecategories],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
      languages: {},
      dpagecategoriestranslationsData: [],
    };
  },
  components: {
    Loader,
    forminput,
    dpagecategoriestranslations
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {

      this.FormData.Websiteid = "34a035fe-de82-406b-a444-9cf9140bcd81";

      this.$v.$touch();
      if (!this.$v.$invalid) {

        if (this.AddEdit == "Add") {

          this.Post("dpagecategories", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.$bvModal.hide("dpagecategories");
            }
          });

        } else {

          this.Update("dpagecategories", this.FormData).then((res) => {
            if (res) {

              this.$emit("TableUpdate");
              this.$bvModal.hide("dpagecategories");
            }
          });
        }
      }
    },
    Get() {
      let Page = {
        PageNumber: "1",
        PageSize: "99999",
        PageDataSize: "1",
      };
      this.ActionsGet({ Service: "languages", Page: Page }).then((res) => {
        this.languages = res.Data;
      });

    },
  },
};
</script>
<template>
  <Loader>


    <b-modal id="dpagecategories" size="lg" :title="
      this.AddEdit == 'Edit'
        ? $t('dpagecategories.AddEdit.FormTitleEdit')
        : $t('dpagecategories.AddEdit.FormTitleAdd')
    " title-class="font-18" hide-footer>
      <b-tabs content-class="p-3 text-muted">
        <b-tab active class="border-0">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <country-flag country="tr" size="small" />
            <span class="d-none d-sm-inline-block">Türkçe</span>
          </template>
          <Form @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-12">
                <forminput :FormDataType="FormDataType.Title" 
                           :Value="FormData.Title" 
                           :v="$v.FormData.Title"
                           @input="FormData.Title = $event" />
              </div>
            </div>
            <button class="btn btn-primary" type="submit">
              {{ $t("dpagecategories.AddEdit.Button") }}
            </button>
          </Form>
        </b-tab>
        <template v-for="(Data, index) in languages">
          <b-tab :key="index" v-if="AddEdit == 'Edit' && Data.Shorttitle != 'tr'">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-user"></i>
              </span>
              <span class="d-none d-sm-inline-block">
                <country-flag :country="Data.Flag" size="small" />{{
                    Data.Title
                }}
              </span>
            </template>
            <dpagecategoriestranslations :DataId="FormData.Id" :LanId="Data.Id" />
          </b-tab>
        </template>
      </b-tabs>
    </b-modal>
  </Loader>
</template>
